import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common/mypg_link_ico.png'
import _imports_1 from '@/assets/common/logout_ico.png'
import _imports_2 from '@/assets/common/menu_ico2_off.png'
import _imports_3 from '@/assets/common/menu_ico2_on.png'
import _imports_4 from '@/assets/common/menu_ico3_off.png'
import _imports_5 from '@/assets/common/menu_ico3_on.png'
import _imports_6 from '@/assets/common/menu_ico4_off.png'
import _imports_7 from '@/assets/common/menu_ico4_on.png'
import _imports_8 from '@/assets/common/menu_close_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-197aa41d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side_user_box" }
const _hoisted_2 = { class: "side_user_links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "side_menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "off"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "on"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스트레스 케어", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "",
    class: "off"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    class: "on"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "커뮤니티", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "",
    class: "off"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "",
    class: "on"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "경찰청 YOUTUBE", -1))
const _hoisted_12 = { class: "side_bottom" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      ($setup.state.isNavOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "back_bg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectMenu($setup.state.selectMenu))),
            style: _normalizeStyle({ display: $setup.state.isNavOpen ? 'block' : 'none' })
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["side_menu_layer", { open: $setup.state.isNavOpen }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString($setup.state.userInfo?.name), 1),
            _createTextVNode(" 님 ")
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: "/mypage",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectMenu('mypage')))
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode("마이페이지")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "#",
              onClick: $setup.logout
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode("로그아웃")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass($setup.state.selectMenu == 'stress' ? 'active' : null)
            }, [
              _createVNode(_component_router_link, {
                to: "/stressCare/category",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectMenu('stress')))
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass($setup.state.selectMenu == 'community' ? 'active' : null)
            }, [
              _createVNode(_component_router_link, {
                to: "/community/list",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectMenu('community')))
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass($setup.state.selectMenu == 'youtube' ? 'active' : null)
            }, [
              _createVNode(_component_router_link, {
                to: "/youtube/list",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectMenu('youtube')))
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11
                ]),
                _: 1
              })
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "side_menu_close",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectMenu(null)))
          }, _hoisted_14)
        ])
      ], 2)
    ]),
    _createVNode(_component_Modal, {
      show: $setup.state.isModalOpen,
      content: $setup.modal.content,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "yes", "no", "onClose"])
  ], 64))
}